import React, { useState, useEffect } from "react"
import { 
    Card, CardBody, CardHeader, CardTitle, Table, Button,
    Row, Col
} from "reactstrap"
import { Link } from "react-router-dom"
import EmailApi from "../../Api/emailApi"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { useNavigate } from "react-router-dom"
import { StandardPagination, ActionIcon } from "components/Common"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import "./EmailSubcription.scss"



const EmailSubcription = () => {
    const [emailSubscriptions, setEmailSubscriptions] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [limit] = useState(10) // items per page
    const navigate = useNavigate()
    const breadcrumbItems = [
        { label: "Home", link: "/" },
        { label: "Email Subscriptions", link: "/emailSubscriptions" },
    ]   
    
    
    useEffect(() => {
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem("token")}`
            }
        }   
        EmailApi.getAllEmailSubscriptions(config)
        .then((response) => {
            setEmailSubscriptions(response.data.data)
            setTotalPages(Math.ceil(response.data.pagination.total / limit))
            setLoading(false)
        })
        .catch((error) => {
            setError(error)
            setLoading(false)
        })
    }, [page, limit])
    const handleBreadcrumbClick = link => {
        if (link !== "#") {
          navigate(link)
        }
      }
    return (
        <>
            <Row>
                <Col xs="12">
                    <div className="email-subcription-header d-flex align-items-center justify-content-between">
                        <CustomBreadCrumb
                            data={breadcrumbItems}
                            pageTitle="Email Subscriptions"
                            handleClick={handleBreadcrumbClick}
                        />
                        
                        <div className="d-flex align-items-center gap-3">
                            {/* Future: Add export or other action buttons here */}
                        </div>
                    </div>

                    <div className="data-table-container">
                        <div className="table-responsive mt-4 mb-3">
                        {loading ? (
                            <DataTableLoader cols={4} />
                        ) : (
                            <Table className="table mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>#</th>
                                        <th>Email</th>
                                        <th>Subscribed At</th>
                                        <th className="text-center">Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {emailSubscriptions.map((subscription, index) => (
                                        <tr key={subscription._id}>
                                            <th scope="row">{(page - 1) * limit + index + 1}</th>
                                            <td>{subscription.email}</td>
                                            <td>{new Date(subscription.createdAt).toLocaleDateString()}</td>
                                            <td className="text-center">
                                                <ActionIcon
                                                    type="delete"
                                                    onClick={() => {}}
                                                    tooltip="Delete Subscription"
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        )}
                        </div>
                    </div>

                    <StandardPagination
                        currentPage={page}
                        totalPages={totalPages}
                        onPageChange={setPage}
                    />
                </Col>
            </Row>
        </>
    )
}

export default EmailSubcription
